import React from "react";
import { IGameType } from "@/types/GlobalTypes";

import BetConfirmedModal from "../components/BetConfirmedModal";
import MessageModal from "../components/MessageModal";
import YouWonModal from "../components/YouWonModal";

export interface SubmitResData {
    status: boolean,
    message: string,
    winamount?: any
}

function clearModals(game: IGameType) {
    delete game.messageModal;
    delete game.betConfirmedModal;
    delete game.winModal;
}

function processResdataToModal(game: IGameType, resdata: SubmitResData) {
    // console.log("pRTM res", resdata);

    if (resdata.winamount) //on recieve_totalwin
        setWinModal(game, Number(resdata.winamount));
    else if (resdata.status) //on clickSubmit
        setBetConfirmedModal(game);
    else setMessageModal(game, resdata.message);
}

function setMessageModal(game: IGameType, message: string) {
    game.messageModal = { message: message };
}

function setBetConfirmedModal(game: IGameType) {
    game.betConfirmedModal = { message: "BET CONFIRMED!" };
}

function setWinModal(game: IGameType, winAmount: number) {
    game.winModal = { winAmount: winAmount };
}

/**
 * Render modal
 * @returns Either bet confirmed, message, or You Won modal
 */
function renderModals(game: IGameType, langStr: string, clearModalsWithPcode: (e: React.MouseEvent) => void) {
    return <>
        {
            game.betConfirmedModal ?
            <BetConfirmedModal
                message={game.betConfirmedModal.message}

                pcode={game.pcode}
                onClose={clearModalsWithPcode}
            /> : null
        }

        {
            game.messageModal ?
            <MessageModal
                message={game.messageModal.message}

                pcode={game.pcode}
                onClose={clearModalsWithPcode}
            /> : null
        }

        {
            game.winModal ?
            <YouWonModal
                langStr={langStr}
                winamount={game.winModal.winAmount}
            /> : null
        }
    </>;
}

export {
    clearModals,
    processResdataToModal,
    setMessageModal,
    setBetConfirmedModal,
    setWinModal,
    renderModals
};
